export const HOME_FEED_POSTS_LOADING_MORE = 'home-feed-posts.loading-more';
